export default __webpack_public_path__ + "static/media/printer.2229a5ce.svg";